"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.getNonce = exports.isSelfTransaction = exports.isValidAddress = void 0;
var bech32 = __importStar(require("bech32"));
/**
 * The human-readable-part of the bech32 addresses.
 */
var HRP = "erd";
/**
 * The length (in bytes) of a public key (from which a bech32 address can be obtained).
 */
var PUBKEY_LENGTH = 32;
function fromBech32(value) {
    var decoded;
    try {
        decoded = bech32.decode(value);
    }
    catch (err) {
        throw new Error("Erd address can't be created");
    }
    var prefix = decoded.prefix;
    if (prefix != HRP) {
        throw new Error("Bad HRP");
    }
    var pubkey = Buffer.from(bech32.fromWords(decoded.words));
    if (pubkey.length != PUBKEY_LENGTH) {
        throw new Error("Erd address can't be created");
    }
    return value;
}
/**
 * Returns true if address is a valid bech32
 *
 * @param {string} address
 */
var isValidAddress = function (address) {
    try {
        fromBech32(address);
        return true;
    }
    catch (error) {
        return false;
    }
};
exports.isValidAddress = isValidAddress;
var isSelfTransaction = function (a, t) {
    return t.recipient === a.freshAddress;
};
exports.isSelfTransaction = isSelfTransaction;
/**
 * Returns nonce for an account
 *
 * @param {Account} a
 */
var getNonce = function (a) {
    var _a;
    var lastPendingOp = a.pendingOperations[0];
    var nonce = Math.max(((_a = a.elrondResources) === null || _a === void 0 ? void 0 : _a.nonce) || 0, lastPendingOp && typeof lastPendingOp.transactionSequenceNumber === "number"
        ? lastPendingOp.transactionSequenceNumber + 1
        : 0);
    return nonce;
};
exports.getNonce = getNonce;
//# sourceMappingURL=logic.js.map